/**
 * Employee shared types
 * Shared type definitions for employee roles and statuses.
 * These are used across auth, layout, and route-guard features.
 */

/**
 * Employee role enum (matches backend Prisma schema)
 */
export type EmployeeRole =
  | 'SYSTEM_ADMIN'
  | 'PURCHASER'
  | 'WAREHOUSE_KEEPER'
  | 'PRODUCTION_PLANNER'
  | 'PRODUCTION_WORKER'
  | 'SALESPERSON'
  | 'SALES_MANAGER'
  | 'FINANCE_STAFF';

/**
 * Employee status enum (matches backend Prisma schema)
 */
export type EmployeeStatus = 'ACTIVE' | 'INACTIVE';

/**
 * All available employee roles (for validation and dropdowns)
 */
export const EMPLOYEE_ROLES: EmployeeRole[] = [
  'SYSTEM_ADMIN',
  'PURCHASER',
  'WAREHOUSE_KEEPER',
  'PRODUCTION_PLANNER',
  'PRODUCTION_WORKER',
  'SALESPERSON',
  'SALES_MANAGER',
  'FINANCE_STAFF',
];
